import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class TurkeyFarmBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TURKEY_FARM;
}

export default TurkeyFarmBuildingTileEntity;
